<script>
    import CardFilter from "./CardFilter.svelte";
    import { fade, crossfade, scale } from "svelte/transition";
    import { paginate, LightPaginationNav } from "svelte-paginate";
    import { onMount } from "svelte";

    let model = [];
    export let data = [];
    export let detailOverview = 0;
    export let contentData = [];
    export let getValideValue;
    export let getValideList = null;
    export let einheitVerbrauch = null;
    export let bezeichnungVebrauch = null;

    let filterCount = 0;
    let showFilters = false;
    let tmpSortDirection;
    let sortDirection;
    let currentPage = 1;
    let pageSize = 12;

    let clsShaddow = "";
    let filterItems = [];
    let oldFilterItems = [];
    let tmpData = [];
    let tmpSearch = '';
    let searchText = '';

    const urlSearchParams = new URLSearchParams(window.location.search);
    let showManufacturer = false;
    let filterValue = urlSearchParams.get('Filter');
    filterValue = ((filterValue) ? filterValue : (window.location.hash.slice(1) ? window.location.hash.slice(1) : 'all'))
    onMount(() => {
        const params = new URLSearchParams(window.location.search);
        const eid = params.get('eid') || null;
        if(eid) {
            const directData = data.filter(item => item.id == eid);
            if(directData.length > 0) {                
                trackVehicleClick(directData[0]);
                load(directData[0]);
            }
        }
        if (filterValue !== "all" || filterValue !== 'beresa-abosite') {
            showManufacturer = (filterValue === 'beresa-abosite') ? true : false;
            if(showManufacturer) {
                handleSearch({target: {form: {elements: {"model[]": {value: filterValue}}}}});
            }
        }
        if (oldFilterItems.length === 0) {
            oldFilterItems = Object.freeze([...data]);
        }
        filterCount = data.length;
        tmpData = renderData(pageSize, currentPage);
    });

    function trackVehicleClick(row) {
        if (window.gtag) {
            try {
                const fahrzeugInfo = [
                    row?.attributes?.Titel || 'k. A.',
                    'Preis:' + (row?.attributes?.Basispreis || 'k. A.') + ' €',
                    row?.attributes?.Availability || 'k. A.'
                ].join(' | ');

                gtag('event', 'abosite_fahrzeug_klick', {
                    'event_category': 'Interaction',
                    'event_label': row?.attributes?.Titel || 'Unbekanntes Fahrzeug',
                    'event_value': fahrzeugInfo,
                    'page_title': document.title,
                    'page_url': window.location.href
                });

            } catch (error) {
                console.error('Fehler beim Senden des Events an Google Analytics:', error);
            }
        }
    }
    function trackVehicleFilter(searchText) {
        if (window.gtag) {
            try {
                gtag('event', 'abosite_fahrzeug_filter', {
                    'event_category': 'Interaction',
                    'event_label': 'Fahrzeug Filter',
                    'event_value': searchText,
                    'page_title': document.title,
                    'page_url': window.location.href
                });

            } catch (error) {
                console.error('Fehler beim Senden des Events an Google Analytics:', error);
            }
        }
    }
    
    const kWhtoPS = (kWh) => {
        const kW = kWh;
        const PS = kW * 1.3596;
        return Math.round(Math.round(PS * 100) / 100);
    }

    function scrollToId(id) {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    }
    
    const load = (data) => {
        setTimeout(() => {
            detailOverview = 1;
        }, 0);
        //detailOverview = 1;
        //scrollToId('beresa-abosite');
        contentData = data;
    };
  
    const [send, receive] = crossfade({
        duration: 200,
        fallback: scale,
    });

    function goToPage(page) {
        currentPage = page;
    }
    function renderData(pageSize, currentPage, resultData) {
        let items = (typeof resultData !== 'undefined') ? resultData : data;
        let result = paginate({ items, pageSize, currentPage });
        //scrollToId('beresa-abosite');
        return result;
    }

    function filteredData() {
        let result;
        let tmpSearch = searchText;
        let tmpSearchArray = Array.isArray(tmpSearch) ? tmpSearch : [tmpSearch]; // tmpSearch in ein Array umwandeln
        result = data;
        if (tmpSearch === '' || tmpSearch.length === 0) {
            result = data;
        } else {
            result = data.filter(item => {
                return tmpSearchArray.some(value => {
                    return ((item.attributes.Titel+' '+item.attributes.Teasertext+' '+item.attributes.Getriebe+' '+item?.attributes.Ausstattung+' '+(item.attributes.Ausstattung[value] == true ? value : '')).toLowerCase().includes(value.toLowerCase()));// || item.attributes.Teasertext.toLowerCase().includes(value.toLowerCase()));
                });
            });
        }
        tmpData = result;
        filterCount = result.length;
        if(filterCount <= pageSize) {
            goToPage(1);
        }
        console.log(searchText, filterCount, model);
        return renderData(pageSize, currentPage, result);
    }

    function handleSearch(event) {
        const checkboxen = event.target.form.elements["model[]"];
        let selectedManufacturers = Array.from(checkboxen).filter(cb => cb.checked).map(cb => cb.value.replaceAll(' ','_'));
        // Prüfe, ob Hersteller ausgewählt ist
        if (selectedManufacturers.length > 0) {
            searchText = selectedManufacturers;
            trackVehicleFilter(searchText);
        } else {
            searchText = '';
            trackVehicleFilter(searchText);
        }
        tmpSearch = searchText;
    }

    function sortItems() {
        let filterItems;
        if(sortDirection === '0') {
            tmpSortDirection = sortDirection;
            filterItems = oldFilterItems;
            return renderData(pageSize, currentPage, filterItems);
        } else {
            tmpSortDirection = sortDirection;
            filterItems = (data.sort((a, b) => sortDirection * (a?.attributes?.Basispreis - b?.attributes?.Basispreis))).length > 0 ? data.sort((a, b) => sortDirection * (a?.attributes?.Basispreis - b?.attributes?.Basispreis)) : null;
            return renderData(pageSize, currentPage, filterItems);
        }
    }

    $: filterItems = ((tmpSortDirection != sortDirection) ? sortItems() : renderData(pageSize, 1, filterItems)) || (searchText !== '' || searchText != tmpSearch) ? filteredData() : renderData(pageSize, currentPage);

</script>

<section id="abositetop" class="pb-20 block" style="min-height:1000px;" on:mousedown={() => {showFilters = false}}>
    <div class="lg:pt-6 pt-6 md:w-4/4 text-center">
        <div class="flex flex-wrap items">
            <div class="pt-6 h-3/4 lg:w-6/12 md:w-6/12 sm:w-6/12 px-2 text-left font-semibold">
                <div class="rounded-lg filterbar" on:mouseup={() => {
                        showFilters =! showFilters
                    }}>
                    <span class="count">{filterCount} Fahrzeuge filtern <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                        <path fill="currentColor" d="M3 4H21V7L14 14V20L10 22V14L3 7V4Z"></path>
                    </svg></span>
                </div>
                <CardFilter {model} {showFilters} {handleSearch}></CardFilter>
            </div>
            <div on:mouseup={() => {
                showFilters = false
            }}
            class="pt-6 h-4/4 lg:w-6/12 md:w-6/12 sm:w-6/12 px-2 text-right"
            >
                <select class="sortbar" bind:value={sortDirection}>
                    <option value="0">---- Preissortierung ----</option>
                    <option value="1">Preis aufwärts sortieren</option>
                    <option value="-1">Preis abwärts sortieren</option>
                </select>
            </div>
        </div>
        <div on:mouseup={() => {showFilters = false; scrollToId('abositetop')}} class="flex flex-wrap items mb-4 pt-2">
        {#each filterItems as row, i (row)}
            <div on:mouseup={() => {
                showFilters = false
            }}
                class="pt-6 h-3/4 lg:w-3/12 md:w-6/12 sm:w-6/12 px-2 text-center item"
                id={row.id}
                on:mouseenter={() => (clsShaddow = i)}
                on:mouseleave={() => (clsShaddow = "")}
                on:mousedown={() => {
                    load(row);
                    trackVehicleClick(row);
                }}
                on:mouseup={() => {
                    showFilters = false;
                }}
                in:receive={{ key: row.id }}
                out:send={{ key: row.id }}
            >
                <div
                class="flex flex-col min-w-0 break-words bg-white lg:w-full mb-8 rounded-lg {clsShaddow ===
                i
                    ? 'shadow-lg'
                    : 'shadow-sm'}"
                >
                <div
                    style="position:relative; background-image: url(https://beresa.machs-mit-marketing.de/abosite/image/id/{row.id}/format/small);"
                    class="image-preview lg:h-auto md:h-96 sm:h-72 max-w-full lg:pt-24 md:pt-12 sm:pt-12 lg:w-96 shadow-sm rounded-t-lg bg-cover bg-left-bottom bg-no-repeat"
                >
                    <div style="min-height:100px; position:absolute; right:0; top:30px;">
                        {#if getValideValue(row?.attributes?.Informationen , 'Antrieb') != '---'}<p style="text-align:right; color:#fff; padding:4px; margin-right:0; margin-bottom:4px; font-size:12px;"><span style="background-color: #6d97a1; font-size:14px; padding:2px; margin-right:0; min-width:70px;">{getValideValue(row?.attributes?.Informationen , 'Antrieb')}</span></p>{/if}
                        <!--{#if getValideValue(row?.attributes , 'Availability') != '-'}<p style="text-align:right; color:#fff; padding:4px; margin-bottom:4px; font-size:11px;"><span style="background-color: #6d97a1; padding:2px;">{getValideValue(row?.attributes , 'Availability')}</span></p>{/if}-->
                    </div>
                </div>
                <div class="lg:pt-6 mt-4 min-h-240px flex-auto text-left" style="min-height:240px; padding:6px;">
                    <h6 class="text-xl p-12 font-semibold">{getValideValue(row?.attributes, 'Titel')}</h6>
                    <small style="line-height:8px;">
                        {#if getValideValue(row?.attributes?.Informationen, 'Leistung') !== '---'}
                            {getValideValue(row?.attributes?.Informationen, 'Leistung')} {einheitVerbrauch(getValideValue(row?.attributes?.Informationen, 'Antrieb')) === 'l' ? 'kW' : 'kW'} ({kWhtoPS(getValideValue(row?.attributes?.Informationen, 'Leistung'))} PS)<br /> 
                        {/if}

                        Energieverbrauch {getValideValue(row?.attributes?.Informationen, 'Antrieb')?.includes('Hybrid') ? 'gewichtet, kombiniert' : 'kombiniert'}<br />
                        {
                            (getValideValue(row?.attributes?.Informationen, 'Antrieb') === 'Elektrisch') ? (getValideValue(row?.attributes?.Emissionen, 'Energieverbrauch_kwh') + ' kWh/100km') :  
                            ( 
                              (getValideValue(row?.attributes?.Informationen, 'Antrieb')?.includes('Hybrid')) ? 
                                getValideValue(row?.attributes?.Emissionen, 'Energieverbrauch_kwh') + ' kWh/100km und ' + row?.attributes?.Emissionen?.Kraftstoffverbrauch_kombiniert + ' ' + bezeichnungVebrauch(getValideValue(row?.attributes?.Informationen , 'Antrieb')) : 
                                row?.attributes?.Emissionen?.Kraftstoffverbrauch_kombiniert + ' ' + bezeichnungVebrauch(getValideValue(row?.attributes?.Informationen , 'Antrieb'))
                            )                        
                        } 
                        <br />
                        {#if getValideValue(row?.attributes?.Emissionen, 'Kraftstoffverbrauch_ent_Bat') !== '-'}
                        Kraftstoffverbrauch bei entl. Batterie<br />{getValideValue(row?.attributes?.Emissionen, 'Kraftstoffverbrauch_ent_Bat')} l/100km <br />
                        {/if}

                        {#if getValideValue(row?.attributes?.Emissionen, 'CO2_Emission_kombiniert')  !== '-'}
                        CO₂-Emission {getValideValue(row?.attributes?.Informationen, 'Antrieb')?.includes('Hybrid') ? 'gewichtet, kombiniert' : 'kombiniert'}<br />{getValideValue(row?.attributes?.Emissionen, 'CO2_Emission_kombiniert')} g/km<br />
                        {/if}
                        
                        {#if getValideValue(row?.attributes?.Emissionen, 'CO2_Klasse_gew_Kombiniert') !== '-'}
                        CO₂-Klasse <b>{(row?.attributes?.Emissionen?.CO2_Klasse_gew_Kombiniert ?? '-').split(':')[0].trim()}</b><br />
                        {/if}
                        
                        {#if row?.attributes?.Emissionen.CO2_Klasse_entl_Batterie !== null}
                        CO₂-Klasse bei entladener Batterie <b>{(row?.attributes?.Emissionen?.CO2_Klasse_entl_Batterie ?? '-').split(':')[0].trim()}</b><br />
                        {/if}
                            

                    </small>
                </div>
               
                <div class="lg:pt-6 mt-4 flex-auto text-center;" style="padding:12px; text-align: center; color:#6d97a1 !important">
                    {#if getValideValue(row?.attributes , 'Availability') != '-'}<h6 class="text-xl p-6 font-semibold">{getValideValue(row?.attributes , 'Availability')}</h6>{/if}&nbsp;                    
                </div>
                
                <div class="lg:pt-6 mt-4 flex-auto text-right" style="padding:6px;">
                    <h6 class="text-xl p-12 font-semibold relative">
                        {#if getValideValue(row?.attributes , 'UVPPreis') != '-'}
                            <small class="strike-through">( {getValideValue(row?.attributes , 'UVPPreis')} €*)</small>
                        {/if}
                        ab {getValideValue(row?.attributes, 'Basispreis')} €
                    </h6><small>mtl. inkl. MwSt</small>
                </div>
            </div>
        </div>
    {/each}
    </div>
    {#if filterItems.length <= 0}
    <div class="lg:pt-6 pt-6 md:w-4/4 px-4 text-center">
        <h2>KEINE PASSENDEN FAHRZEUGE GEFUNDEN.</h2>
        <p>Diese Filterkombination erzielt keine Treffer. Bitte wählen Sie eine andere<br />Filtereinstellungen, um mehr Ergebnisse zu erhalten.</p>
        <!--<button id="resetFilter" value="" on:mouseup={model = null}>Filter zurücksetzen</button>-->
    </div>
    {:else}
    <div class="lg:pt-6 pt-6 md:w-4/4 px-4 text-center">
        <div class="flex flex-col min-w-0 break-words mb-8">
            <div class="px-4 py-5 flex-auto" on:mouseup={() => {
                showFilters = false;
                scrollToId('abositetop')
            }}>
                <LightPaginationNav
                    totalItems={tmpData.length}
                    {pageSize}
                    {currentPage}
                    limit={1}
                    showStepOptions={true}
                    on:goToStep{goToPage}
                    on:setPage={(e) => (currentPage = e.detail.page)}
                />
            </div>
        </div>
    </div>
    <div class="lg:pt-6 pt-6 md:w-4/4 px-4 text-left">
        <div class="flex flex-col min-w-0 break-words mb-8">
            <small>*Niedrigster Preis der letzten 30 Tage.</small>
        </div>
    </div>
    {/if}
</section>

<style>
.strike-through {
    position: relative;
}

.strike-through::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    width: 100%;
    border-top: 2px solid red; /* Farbe und Dicke des Durchstreichens anpassen */
    transform: rotate(-15deg);
    transform-origin: center;
}
.filterbar {
    background-color: #6d97a1;
    padding: 8px;
    margin: 2px;
    line-height: 20px;
    min-width: 160px;
    text-align: center;
    display: inline-block;
    color: #ffffff;
}
.sortbar {
    font-size: 18px !important;
    border-color: #6d97a1;
    padding: 8px;
    margin: 2px;
    line-height: 20px;
    min-width: 240px;
    display: inline-block;
    color: #000000;
}

:global(.image-preview) {
    min-height: 270px !important;
}

.image-preview {
    background-size: cover !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
    width: 100%;
    height: 100%;
    min-height: 340px;
}

@media (min-width: 240px) and (max-width: 639px) {
    .item {
        width: 100% !important;
    }
}
.flex {
    display: flex;
}
.filterbar, 
.sortbar,
.item,
label,
button, 
select {
    cursor: pointer;
}
.count {
    display: flex;
    align-items: center;
    gap: 8px; /* Abstand zwischen Text und Icon */
}

.count svg {
    width: 18px;  /* Größe anpassen */
    height: 18px;
}
</style>